// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmdashpg-inline-1 {
  text-align: center;
  padding: 60px 20px;
}

.pmdashpg-inline-2 {
  margin: 0 auto 20px;
}

.pmdashpg-inline-3 {
  font-size: 14px;
  color: #64748b;
}

.pmdashpg-inline-4 {
  font-size: 12px;
  font-weight: 400;
  color: #64748b;
  margin-left: 12px;
}

.pmdashpg-inline-5 {
  padding: 24px;
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
}

.pmdashpg-inline-6 {
  font-size: 12px;
  font-weight: 600;
}

.pmdashpg-inline-7 {
  font-size: 10px;
  color: #94a3b8;
}

.pmdashpg-inline-8 {
  font-size: 10px;
  color: #64748b;
  margin-top: 2px;
}

.pmdashpg-inline-9 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pmdashpg-inline-10 {
  width: 80px;
  height: 6px;
  background: #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
}

.pmdashpg-inline-11 {
  padding: 0;
}

.pmdashpg-inline-12 {
  padding: 24px;
  font-size: 12px;
  color: #2563eb;
  text-align: center;
}

.pmdashpg-inline-13 {
  border-bottom: 1px solid #f1f5f9;
}

.pmdashpg-inline-14 {
  font-size: 12px;
  font-weight: 600;
}

.pmdashpg-inline-15 {
  font-size: 10px;
  color: #94a3b8;
}

.pmdashpg-inline-16 {
  border-bottom: 1px solid #f1f5f9;
}

.pmdashpg-inline-17 {
  font-size: 12px;
  font-weight: 600;
}

.pmdashpg-inline-18 {
  font-size: 10px;
  color: #94a3b8;
}

.pmdashpg-inline-19 {
  background: #d97706;
}

.pmdashpg-inline-20 {
  font-size: 12px;
  font-weight: 600;
}

.pmdashpg-inline-21 {
  font-size: 10px;
  color: #94a3b8;
}

.pmdashpg-inline-22 {
  background: #2563eb;
}

.pmdashpg-inline-23 {
  font-size: 12px;
  font-weight: 600;
}

.pmdashpg-inline-24 {
  font-size: 10px;
  color: #94a3b8;
}

.pmdashpg-inline-25 {
  background: #0ea5e9;
}

.pmdashpg-inline-26 {
  padding: 24px;
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
}

.pmdashpg-inline-27 {
  font-size: 12px;
  font-weight: 600;
}

.pmdashpg-inline-28 {
  font-size: 10px;
  color: #94a3b8;
}

.pmdashpg-inline-29 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pmdashpg-inline-30 {
  width: 60px;
  height: 5px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}

.pmdashpg-inline-31 {
  padding: 24px;
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
}

.pmdashpg-inline-32 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.pmdashpg-inline-34 {
  font-size: 11px;
  font-weight: 600;
}

.pmdashpg-inline-35 {
  font-size: 10.5px;
  color: #475569;
  margin-bottom: 4px;
}

.pmdashpg-inline-36 {
  font-size: 9px;
  color: #94a3b8;
}

.pmdashpg-inline-37 {
  height: 220px;
}

.pmdashpg-dyn-1 {
  border-left: var(--pmdashpg-1-border-left);
}

.pmdashpg-dyn-2 {
  color: var(--pmdashpg-2-color);
}

.pmdashpg-dyn-3 {
  color: var(--pmdashpg-3-color);
}

.pmdashpg-dyn-4 {
  height: 100%;
  width: var(--pmdashpg-4-width);
  background: var(--pmdashpg-4-background);
  border-radius: 6px;
}

.pmdashpg-dyn-5 {
  font-size: 11px;
  font-weight: 700;
  color: var(--pmdashpg-5-color);
}

.pmdashpg-dyn-6 {
  height: 100%;
  width: var(--pmdashpg-6-width);
  background: var(--pmdashpg-6-background);
  border-radius: 4px;
}

.pmdashpg-dyn-7 {
  background: var(--pmdashpg-7-background);
  color: var(--pmdashpg-7-color);
  border-color: var(--pmdashpg-7-border-color);
}

.pmdashpg-dyn-8 {
  padding: 12px 0;
  border-bottom: var(--pmdashpg-8-border-bottom);
}

.pmdashpg-dyn-9 {
  font-size: 9px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMDashPg.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".pmdashpg-inline-1 {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.pmdashpg-inline-2 {\n  margin: 0 auto 20px;\n}\n\n.pmdashpg-inline-3 {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pmdashpg-inline-4 {\n  font-size: 12px;\n  font-weight: 400;\n  color: #64748b;\n  margin-left: 12px;\n}\n\n.pmdashpg-inline-5 {\n  padding: 24px;\n  font-size: 12px;\n  color: #94a3b8;\n  text-align: center;\n}\n\n.pmdashpg-inline-6 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pmdashpg-inline-7 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.pmdashpg-inline-8 {\n  font-size: 10px;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.pmdashpg-inline-9 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pmdashpg-inline-10 {\n  width: 80px;\n  height: 6px;\n  background: #e2e8f0;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.pmdashpg-inline-11 {\n  padding: 0;\n}\n\n.pmdashpg-inline-12 {\n  padding: 24px;\n  font-size: 12px;\n  color: #2563eb;\n  text-align: center;\n}\n\n.pmdashpg-inline-13 {\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.pmdashpg-inline-14 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pmdashpg-inline-15 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.pmdashpg-inline-16 {\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.pmdashpg-inline-17 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pmdashpg-inline-18 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.pmdashpg-inline-19 {\n  background: #d97706;\n}\n\n.pmdashpg-inline-20 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pmdashpg-inline-21 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.pmdashpg-inline-22 {\n  background: #2563eb;\n}\n\n.pmdashpg-inline-23 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pmdashpg-inline-24 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.pmdashpg-inline-25 {\n  background: #0ea5e9;\n}\n\n.pmdashpg-inline-26 {\n  padding: 24px;\n  font-size: 12px;\n  color: #94a3b8;\n  text-align: center;\n}\n\n.pmdashpg-inline-27 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pmdashpg-inline-28 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.pmdashpg-inline-29 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pmdashpg-inline-30 {\n  width: 60px;\n  height: 5px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.pmdashpg-inline-31 {\n  padding: 24px;\n  font-size: 12px;\n  color: #94a3b8;\n  text-align: center;\n}\n\n.pmdashpg-inline-32 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.pmdashpg-inline-34 {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.pmdashpg-inline-35 {\n  font-size: 10.5px;\n  color: #475569;\n  margin-bottom: 4px;\n}\n\n.pmdashpg-inline-36 {\n  font-size: 9px;\n  color: #94a3b8;\n}\n\n.pmdashpg-inline-37 {\n  height: 220px;\n}\n\n.pmdashpg-dyn-1 {\n  border-left: var(--pmdashpg-1-border-left);\n}\n\n.pmdashpg-dyn-2 {\n  color: var(--pmdashpg-2-color);\n}\n\n.pmdashpg-dyn-3 {\n  color: var(--pmdashpg-3-color);\n}\n\n.pmdashpg-dyn-4 {\n  height: 100%;\n  width: var(--pmdashpg-4-width);\n  background: var(--pmdashpg-4-background);\n  border-radius: 6px;\n}\n\n.pmdashpg-dyn-5 {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--pmdashpg-5-color);\n}\n\n.pmdashpg-dyn-6 {\n  height: 100%;\n  width: var(--pmdashpg-6-width);\n  background: var(--pmdashpg-6-background);\n  border-radius: 4px;\n}\n\n.pmdashpg-dyn-7 {\n  background: var(--pmdashpg-7-background);\n  color: var(--pmdashpg-7-color);\n  border-color: var(--pmdashpg-7-border-color);\n}\n\n.pmdashpg-dyn-8 {\n  padding: 12px 0;\n  border-bottom: var(--pmdashpg-8-border-bottom);\n}\n\n.pmdashpg-dyn-9 {\n  font-size: 9px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
